import React, { useState } from 'react';
import {SearchBar, Icons} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import ConfirmationModal from  './confirmationModal';
import { Button } from '@xpertdox_js/xdcomponents';
import { trackError } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext';

const EditNct = (props) => {
  const { data } = props
  const instance = data.instance;
  const [nctArr, setNctArr] = React.useState(data.trials)
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [nct, setNct] = useState(null);
  const { userAction } = React.useContext(UserContext);

  const user = {
    instance: data.instance,
    email: data.email,
    id: data._id
  }
  const addConditions = term => {
    const dataObj = {
      user,
      trial: term
    }
    axios.post(`${axiosConfig.apiUrl}/rt/console/addPiTrial/${user.email}`, dataObj)
    .then(response => {
      let newArray = [...new Set([...nctArr, term])]
      setNctArr(newArray)
      // props.userDetails();
      // props.dataRefresh();
    }).catch(error => {
      console.log('error', error);
      trackError({ error: error, history: props.history })
      if (error.response.status === 403) {
        userAction({type: 'logout'})
      }
    });
    closeModal();
  }

  const deleteCondition = term => {
    axios.get(`${axiosConfig.apiUrl}/rt/console/deleteNct/${term}/${user.instance}/${user.email}`)
    .then(response => {
      let newArray = [...nctArr]
      newArray.splice(newArray.indexOf(term), 1);
      setNctArr([new Set(newArray)])
      // props.userDetails();
      // props.dataRefresh();
    }).catch(error => {
      console.log('error', error);
      trackError({ error: error, history: props.history })
      if (error.response.status === 403) {
        userAction({type: 'logout'})
      }

    });
    closeModal();
  }

  const openModal = (term, type='add') => {
    if (type === 'delete') {
      setNct(term);
      setConfirmDelete(true);
    } else {
      setNct(term._id);
      setConfirmDelete(false);
    }
    setShowModal(true);
  }

  const closeModal = () => {
    setNct(null);
    setConfirmDelete(false);
    setShowModal(false);
  }

  return (
    <React.Fragment>
      <div style={styles.searchBarContainer}>
        <SearchBar
          axiosConfig={axiosConfig}
          {...props}
          type='trials'
          context={{instance: instance}}
          selected={openModal}
          containerStyles={styles.searchBar}
          editNcts
        />
      </div>
      {nctArr && nctArr.length > 0 &&
        <React.Fragment>
          <div style={styles.nct}>
            {nctArr.map((value, index) => {
              return (
                <Button
                  key={index}
                  id={`nct_${index}`}
                  styles={styles.nctContainer}
                  hoverStyles={styles.nctHover}
                >
                  {value}
                  <Icons icon='times' style={styles.icon} onClick={() => openModal(value, 'delete')} />
                </Button>
              )
            })}
          </div>
        </React.Fragment>
      }
      {showModal &&
        <ConfirmationModal
          question={
            confirmDelete
            ? `Are you sure you want to remove '${nct ? nct : ''}' ?`
            : `Are you sure you want to add '${nct ? nct : ''}' ?`
          }
          showModal={showModal}
          acceptText={confirmDelete ? 'Remove trial' : 'Add Trial'}
          declineText='Cancel'
          nct={nct}
          addConditions={confirmDelete ? deleteCondition : addConditions}
          closeModal={closeModal}
        />
      }
    </React.Fragment>
  )
}

export default EditNct;
